export interface MeetingTypeDescription {
    description: string;
    themeId?: string;
    privacyType?: BookingPrivacyType;
}

export enum BookingPrivacyType {
    PublicMeetingType = 0,
    PrivateMeetingType = 1,
}
